import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

type DividerProps = {
  className?: string;
};

export function Divider({ className }: DividerProps) {
  return <hr className={clsx(styles.divider, className)} aria-hidden="true" />;
}
